import React from 'react';

export function Inicio() {
	return (
		<h5>Bem vindo(a)</h5>
	);
}
